module.exports = __webpack_public_path__ + "static/img/ztx.a4debda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ztx.png
// module id = 429
// module chunks = 2